export const SESSION_DURATION_MS = 60 * 60 * 1000;
export const SESSION_EXPIRY_KEY = "sessionExpiry";
const SESSION_DETAIL_CONFIG = {
  user: { defaultValue: "" },
  userName: { defaultValue: "" },
  userId: { defaultValue: "" },
  profilerUrl: { defaultValue: "" },
  profilerUrlReady: { defaultValue: "false" },
  ibmToken: { defaultValue: "" },
  xtvmAllowed: { defaultValue: "false" },
  altDataAllowed: { defaultValue: "false" },
  ibmAllowed: { defaultValue: null },
  ibmRestricted: { defaultValue: "" },
};

const SESSION_DETAIL_KEYS = Object.keys(SESSION_DETAIL_CONFIG);
const SESSION_STORAGE_KEYS = ["token", ...SESSION_DETAIL_KEYS, SESSION_EXPIRY_KEY];

export function setSessionToken(token) {
  const expiry = Date.now() + SESSION_DURATION_MS;
  localStorage.setItem("token", token);
  localStorage.setItem(SESSION_EXPIRY_KEY, String(expiry));
  return expiry;
}

export function getSessionExpiry() {
  const rawValue = localStorage.getItem(SESSION_EXPIRY_KEY);
  if (!rawValue) return null;

  const expiry = Number(rawValue);
  return Number.isFinite(expiry) ? expiry : null;
}

export function clearSession() {
  SESSION_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function setSessionDetails(details = {}) {
  SESSION_DETAIL_KEYS.forEach((key) => {
    const config = SESSION_DETAIL_CONFIG[key];
    const value = details[key];
    const hasValue = value != null;

    if (hasValue) {
      localStorage.setItem(key, String(value));
      return;
    }

    if (config.defaultValue === null) {
      localStorage.removeItem(key);
      return;
    }

    localStorage.setItem(key, String(config.defaultValue));
  });
}

export function setSessionData({ token, ...details }) {
  if (token) {
    setSessionToken(token);
  }

  setSessionDetails(details);
}

export function getSessionValue(key) {
  if (!SESSION_STORAGE_KEYS.includes(key)) return null;
  if (key === "token") return getSessionToken();
  if (key === SESSION_EXPIRY_KEY) return getSessionExpiry();

  if (isSessionExpired()) return null;

  const rawValue = localStorage.getItem(key);
  if (rawValue == null) {
    return SESSION_DETAIL_CONFIG[key]?.defaultValue ?? null;
  }

  return rawValue;
}

export function getSessionString(key) {
  const value = getSessionValue(key);
  return value == null ? "" : String(value);
}

export function getSessionBoolean(key, fallback = false) {
  const value = getSessionValue(key);
  if (value == null || value === "") return fallback;
  return String(value) === "true";
}

export function isSessionExpired() {
  const token = localStorage.getItem("token");
  const expiry = getSessionExpiry();

  if (!token || !expiry) {
    if (token || expiry) clearSession();
    return true;
  }

  if (Date.now() >= expiry) {
    clearSession();
    return true;
  }

  return false;
}

export function getSessionToken() {
  if (isSessionExpired()) return null;
  return localStorage.getItem("token");
}

export function hasActiveSession() {
  return !!getSessionToken();
}
